import { render, staticRenderFns } from "./endOfDays.vue?vue&type=template&id=e641d026"
import script from "./endOfDays.vue?vue&type=script&lang=js"
export * from "./endOfDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports